import React, { useRef, useState } from 'react';
import {
  IoChevronDownOutline, IoMedkitOutline, IoBriefcaseOutline, IoClipboardOutline,
} from 'react-icons/io5';
import { RiHandCoinLine } from 'react-icons/ri';
import { FiBox } from 'react-icons/fi';
import { format } from 'date-fns';
import uniqid from 'uniqid';

import styles from './ServiceView.module.scss';

export default function ServiceView({
  service, projects = [], drugs = [], pathologies = [],
}) {
  const [isOpen, setIsOpen] = useState(false);
  const contentRef = useRef();
  const safeDrugs = (drugs || []).filter(Boolean);
  const medicalProjects = projects.filter((p) => p?.type === 'medical');
  const marketingProjects = projects.filter((p) => p?.type === 'marketing');

  return (
    <div className={styles.container}>
      <div className={styles.title}>
        <h2>{service.name}</h2>
        <button
          type="button"
          onClick={() => setIsOpen(!isOpen)}
          className={`${styles.toggle} ${isOpen ? styles.open : ''}`}
        >
          <IoChevronDownOutline size={20} />
        </button>
      </div>
      {!isOpen && (
        <div className={styles['icon-row']}>
          <div className={styles.icon}>
            <FiBox size={20} />
            {' '}
            {service.drugs?.length || 0}
          </div>
          <div className={styles.icon}>
            <IoClipboardOutline size={22} />
            {' '}
            {service.pathologies?.length || 0}
          </div>
          <div className={styles.icon}>
            <RiHandCoinLine size={24} />
            {' '}
            {service.donations?.length || 0}
          </div>
          <div className={styles.icon}>
            <IoMedkitOutline size={22} />
            {' '}
            {medicalProjects.length}
          </div>
          <div className={styles.icon}>
            <IoBriefcaseOutline size={22} />
            {' '}
            {marketingProjects.length}
          </div>
        </div>
      )}
      <div
        style={{ height: isOpen ? 'auto' : 0 }}
        className={styles.content}
      >
        <div ref={contentRef}>
          {safeDrugs.length > 0 && (
            <section>
              <div className={styles.sectionTitle}>
                <FiBox size={20} />
                {' '}
                Produits associés
              </div>
              <div className={styles.list}>
                {safeDrugs.map((d) => (
                  <div key={d?._id || uniqid()} className={styles.item}>
                    <p>{d?.name}</p>
                  </div>
                ))}
              </div>
            </section>
          )}
          {service.pathologies?.length > 0 && (
            <section>
              <div className={styles.sectionTitle}>
                <IoClipboardOutline size={20} />
                {' '}
                Pathologies
              </div>
              <div className={styles.pathologies}>
                {service.pathologies.map((d) => {
                  const patho = pathologies?.find((p) => p._id === d.pathology);
                  return (
                    <div key={uniqid()} className={styles.pathology}>
                      <div className={styles.name}>{patho?.name}</div>
                      <div className={styles.form}>
                        {d.form?.filter((f) => f.value && f.name).map((f) => (
                          <div key={f._id || f.name} className={styles.field}>
                            <label>{f.label}</label>
                            {f.value && (
                              <p>
                                {f.type === 'date' && new Date(f.value).getTime()
                                  ? format(new Date(f.value), 'dd/MM/yyyy')
                                  : f.value}
                              </p>
                            )}
                          </div>
                        ))}
                      </div>
                    </div>
                  );
                })}
              </div>
            </section>
          )}
          {service?.donations?.length > 0 && (
            <section>
              <div className={styles.sectionTitle}>
                <RiHandCoinLine size={20} />
                {' '}
                Dons
              </div>
              <div className={styles.list}>
                {service.donations.map((d) => (
                  <div key={uniqid()} className={styles.item}>
                    <div className={styles.don}>
                      {d?.url
                        ? (
                          <a href={d.url} rel="noreferrer" target="_blank">
                            {d?.name}
                          </a>
                        )
                        : <p>{d?.name}</p>}
                      <p>
                        {d?.amount}
                        {' '}
                        €
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            </section>
          )}
          {medicalProjects.length > 0 && (
            <section>
              <div className={styles.sectionTitle}>
                <IoMedkitOutline size={18} />
                {' '}
                Projets médicaux
              </div>
              <div className={styles.list}>
                {medicalProjects.map((d) => (
                  <div key={uniqid()} className={styles.item}>
                    <p>{d.label}</p>
                  </div>
                ))}
              </div>
            </section>
          )}
          {marketingProjects.length > 0 && (
            <section>
              <div className={styles.sectionTitle}>
                <IoBriefcaseOutline size={18} />
                {' '}
                Projets marketing
              </div>
              <div className={styles.list}>
                {marketingProjects.map((d) => (
                  <div key={uniqid()} className={styles.item}>
                    <p>{d.label}</p>
                  </div>
                ))}
              </div>
            </section>
          )}
        </div>
      </div>
    </div>
  );
}
